var exports = {
  "PlayButton": "PlayButton__8g3Kj4",
  "PlayButton--small": "PlayButton--small__PfOp06",
};

__webpack_require__.r(module.exports = exports);
